<div *ngIf="!!loaded && submitForm; else loading">
  <div class="modal-header">
    <h4 class="modal-title" translate>{{ activity?.id ? 'ACTIVITY_EDIT' : 'ACTIVITY_CREATE' }}</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <form [formGroup]="submitForm">
      <div class="row" *ngIf="!activity?.id">
        <div class="col-12">
          <ng-container *ngTemplateOutlet="searchElementCustomer"></ng-container>
          <!-- <lib-gung-text-input [renderStatic]="true" [gungTranslate]="'CUSTOMER'" formControlName="customer"></lib-gung-text-input> -->
          <lib-forms-message-error [controller]="submitForm.get('customer')"></lib-forms-message-error>
        </div>
      </div>
      <div class="row mt-2">
        <div class="col-12">
          <lib-meta-data-select-input
            formControlName="customerResponsible"
            table="salj"
            metaId="saljare"
            metaDisplay="saljarenamn"
            prefix="@CUSTOMERRESPONSIBLE"
            hideEmptyOption="true"
            label="CUSTOMER_RESPONSIBLE"
            labelClass="col-12 font-weight-normal"
          ></lib-meta-data-select-input>
          <lib-forms-message-error [controller]="submitForm.get('status')"></lib-forms-message-error>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <lib-meta-data-select-input
            formControlName="status"
            table="ACTIVITYINTERNALSTATUS"
            metaId="id"
            metaDisplay="name"
            prefix="@ACTIVITYINTERNALSTATUS"
            hideEmptyOption="true"
            label="STATUS"
            labelClass="col-12 font-weight-normal"
          ></lib-meta-data-select-input>
          <lib-forms-message-error [controller]="submitForm.get('status')"></lib-forms-message-error>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-md-6">
          <lib-gung-date-picker
            label="ACTIVITY_DATE"
            [currentselectedDate]="submitForm.get('activityDate').value"
            [minInitialDate]="minDatePickerDate"
            (selectedDate)="updateDate($event, 'activityDate')"
          ></lib-gung-date-picker>
          <lib-forms-message-error [controller]="submitForm.get('activityDate')"></lib-forms-message-error>
        </div>
        <div class="col-12 col-md-3">
          <div class="form-group">
            <label class="w-100" for="meeting-time" translate>ACTIVITY_TIME</label>
            <div class="d-flex">
              <input
                type="time"
                name="time"
                id="date"
                class="form-control"
                [value]="getCurrentHoursString('activityDate')"
                (change)="updateTime($event.target.value, 'activityDate')"
              />
            </div>
            <!--<input class="form-control" type="datetime-local" id="meeting-time" name="meeting-time" min="{{minDate.toISOString().slice(0,-8)}}" formControlName="activityDate">-->
            <lib-forms-message-error [controller]="submitForm.get('activityDate')"></lib-forms-message-error>
          </div>
        </div>
        <div class="col-12 col-md-3">
          <div class="form-group">
            <label class="w-100" for="meeting-time" translate>ACTIVITY_END_TIME</label>
            <div class="d-flex">
              <input
                type="time"
                name="time"
                id="date"
                class="form-control"
                [value]="getCurrentHoursString('activityEndDate')"
                (change)="updateTime($event.target.value, 'activityEndDate')"
              />
            </div>
            <!--<input class="form-control" type="datetime-local" id="meeting-time" name="meeting-time" min="{{minDate.toISOString().slice(0,-8)}}" formControlName="activityDate">-->
            <lib-forms-message-error [controller]="submitForm.get('activityEndDate')"></lib-forms-message-error>
          </div>
        </div>
      </div>

      <div class="row mt-2">
        <div class="col-12">
          <ng-container *ngTemplateOutlet="searchElement"></ng-container>
        </div>
      </div>

      <div class="row mt-2">
        <div class="col-12">
          <lib-meta-data-select-input
            formControlName="type"
            table="ACTIVITYINTERNALTYPE"
            metaId="id"
            metaDisplay="name"
            prefix="@ACTIVITYINTERNALTYPE"
            label="ACTIVITY_TYPE"
            hideEmptyOption="true"
            labelClass="col-12 font-weight-normal"
          ></lib-meta-data-select-input>
          <lib-forms-message-error [controller]="submitForm.get('type')"></lib-forms-message-error>
        </div>
      </div>

      <div class="row">
        <div class="col-12" formGroupName="extra">
          <lib-meta-data-select-input
            formControlName="meetingType"
            table="MEETINGTYPE"
            metaId="id"
            metaDisplay="name"
            prefix="@MEETINGTYPE"
            label="MEETING_TYPE"
            hideEmptyOption="true"
            labelClass="col-12 font-weight-normal"
          ></lib-meta-data-select-input>
          <lib-forms-message-error [controller]="submitForm.get('meetingType')"></lib-forms-message-error>
        </div>
      </div>

      <div class="row">
        <div class="col-12" formGroupName="extra">
          <lib-gung-text-input [gungTranslate]="'ORDER_VALUE'" formControlName="orderValue"></lib-gung-text-input>
          <lib-forms-message-error [controller]="submitForm.get('orderValue')"></lib-forms-message-error>
        </div>
      </div>

      <div class="row mt-3">
        <div class="col-12 form-group" formGroupName="extra">
          <label class="form-check-label" for="SPOKENINSTORE" translate> SPOKEN_IN_STORE </label>
          <input type="checkbox" formControlName="spokenInStore" class="form-check" id="SPOKENINSTORE" />
          <lib-forms-message-error [controller]="submitForm.get('spokenInStore')"></lib-forms-message-error>
        </div>
      </div>

      <div class="row mt-3" *ngIf="!activity?.id">
        <div class="col-12">
          <div class="form-group">
            <label for="comment" class="control-label" translate>COMMENT</label>
            <textarea
              class="form-control"
              type="text"
              name="comment"
              id="comment"
              formControlName="comment"
              rows="5"
            ></textarea>
          </div>
        </div>
      </div>
      <div class="row mt-2" *ngIf="!activity?.id">
        <div class="col-12">
          <div class="form-group">
            <label class="w-100" for="file-upload" translate>ATTACH_FILES</label>
            <input
              #inputFile
              type="file"
              class=""
              id="file-upload"
              aria-describedby="file-upload"
              [multiple]="multipleFiles"
              (change)="onFileSelect($event.target.files)"
              [disabled]="disabled ? true : null"
            />
          </div>
        </div>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="activeModal.close('Cance click')" translate>CANCEL</button>
    <button type="button" class="btn btn-primary" [disabled]="disabled ? true : null" (click)="onSave()" translate>
      SAVE
    </button>
  </div>
</div>

<ng-template #searchElement>
  <div class="">
    <label for="typeahead-prevent-manual-entry" translate>CONTACT</label>
    <input
      #searchInput
      id="typeahead-prevent-manual-entry"
      type="text"
      class="form-control"
      [(ngModel)]="contactSearch"
      [disabled]="customerContacts.length <= 0"
      [ngbTypeahead]="search"
      [inputFormatter]="resultFormatter"
      [resultFormatter]="resultFormatter"
      (selectItem)="selectItem($event, searchInput)"
      placeholder="{{ (customerContacts.length > 0 ? 'CONTACT' : 'NO_AVAILABLE_CONTACTS') | translate }}"
      (focusout)="focusout($event, contactSearch)"
      (focus)="openContacts($event)"
      [showHint]="false"
      [editable]="false"
    />
  </div>
</ng-template>

<ng-template #searchElementCustomer>
  <div class="">
    <label for="typeahead-prevent-manual-entry" translate>CUSTOMER</label>
    <input
      id="typeahead-prevent-manual-entry"
      type="text"
      class="form-control"
      #searchInputCustomer
      [(ngModel)]="modelSearchCustomer"
      [ngbTypeahead]="searchCustomer"
      [inputFormatter]="formatterCustomer"
      [resultFormatter]="formatterCustomer"
      (selectItem)="selectItemCustomer($event, searchInputCustomer)"
      (blur)="changeCustomer($event.target.value)"
      (focusout)="focusoutCustomer($event, modelSearchCustomer)"
      [showHint]="false"
      [editable]="false"
    />
  </div>
</ng-template>

<ng-template #loading> LOADING <i class="fas fa-spinner fa-spin ml-2"></i> </ng-template>
